export class DeadlineReachedError extends Error {
    constructor(deadlineMs: number, slopMs: number) {
        super(`Deadline expired after ${deadlineMs}ms + ${slopMs}ms`);
    }
}
